/** @jsxImportSource @emotion/react */
import { Trans, useLingui } from '@lingui/react/macro';
import { selectPlayers } from 'modules/main/store/main-page';
import Scorers from 'modules/main/ui/components/section/components/scorers/scorers';
import ValueGroup from 'modules/main/ui/components/section/components/value-group/value-group';
import Section from 'modules/main/ui/components/section/section';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import UserIcon from 'ud-ui/components/icon/user-icon';
import Text from 'ud-ui/components/text';

interface IProps extends DivProps {
  loading?: boolean;
}

function SectionPlayers(props: IProps) {
  const { loading, ...rest } = props;
  const { t } = useLingui();
  const navigate = useNavigate();
  const { total, declared, bestScorers } = useSelector(selectPlayers);

  // Игрок без id (бэкенд не прислал `user`) — открывать нечего.
  const handleScorerClick = (scorerId: number) => {
    if (scorerId) navigate(Pages.PLAYERS.builders.view(scorerId));
  };

  const values = [
    { label: t`всего`, value: total.toString() },
    { label: t`заявлены`, value: declared.toString() },
  ];

  return (
    <Section
      icon={<UserIcon />}
      header={t`Игроки`}
      buttonText={t`Добавить игроков`}
      onClickButton={() => navigate(Pages.PLAYERS.CREATE)}
      onClickExtend={() => navigate(Pages.PLAYERS.INDEX)}
      isShowButton={total < 1}
      loading={loading}
      {...rest}
    >
      <ValueGroup values={values} className="mb-5" />
      {bestScorers.length ? (
        <div className="flex flex-col gap-5">
          <div className="flex flex-col">
            <Text variant="body-1" color={theme.colors.InkPrimary} className="mt-2.5">
              <Trans>Лучшие бомбардиры</Trans>
            </Text>
            <Text variant="subtitle-2" color={theme.colors.WhiteGray} className="mt-1">
              <Trans>Больше всех забили голов</Trans>
            </Text>
          </div>
          <Scorers scorers={bestScorers} onScorerClick={handleScorerClick} />
        </div>
      ) : (
        <div className="flex flex-col">
          <Text variant="body-1" color={theme.colors.InkPrimary} className="mt-2.5">
            <Trans>Лучшие бомбардиры</Trans>
          </Text>
          <Text variant="subtitle-2" color={theme.colors.WhiteGray} className="mt-1">
            <Trans>В списке нет игроков</Trans>
          </Text>
        </div>
      )}
    </Section>
  );
}

export default SectionPlayers;
